import React, { ReactNode } from 'react';
import { User } from '../../../interfaces/backend/User';
import { CodeType } from '../CodeType';
import { BuildCodeParams } from './CodeSample';
import Paragraph from 'antd/lib/typography/Paragraph';
import CodeBlock from '../CodeBlock';
import { readWebsiteVariable } from '../../../utils/readWebsiteVariable';
import { BackendCodeSample, UserObjectStringMap } from './BackendCodeSample';

/* eslint-disable no-useless-escape */
export default class BackendPostmanSample extends BackendCodeSample {
  name = 'Postman';
  language = 'json';
  codeType = CodeType.BACKEND;
  tabIcon = '';
  commentChar = undefined;

  buildCode({
    environment,
    notification,
    user,
    mergeTags
  }: BuildCodeParams): ReactNode {
    const url = new URL(
      `/${environment.clientId}/sender`,
      `https://${readWebsiteVariable('REACT_APP_api_domain')}`
    );

    const code = `{
  "info": {
    "_postman_id": "ffe3fa1e-8981-44df-b8f9-df72473b28bc",
    "name": "NotificationAPI",
    "schema": "https://schema.getpostman.com/json/collection/v2.1.0/collection.json",
    "_exporter_id": "31492925"
  },
  "item": [
    {
      "name": "Send Notification",
      "request": {
        "auth": {
          "type": "basic",
          "basic": [
            {
              "key": "password",
              "value": "${environment.clientSecret}",
              "type": "string"
            },
            {
              "key": "username",
              "value": "${environment.clientId}",
              "type": "string"
            }
          ]
        },
        "method": "POST",
        "header": [],
        "body": {
          "mode": "raw",
          "raw": "{\\\"notificationId\\\": \\\"${
            notification.notificationId
          }\\\", \\\"user\\\": { ${this.buildUserObjectString(
      user,
      ' '
    )} }, \\\"mergeTags\\\": ${JSON.stringify(mergeTags, null, 0).replace(
      /"/g,
      '\\"'
    )}}"
        },
        "url": {
          "raw": "${url.href}",
          "protocol": "${url.protocol.replace(':', '')}",
          "host": ${JSON.stringify(url.host.split('.'))},
          "path": ${JSON.stringify(url.pathname.split('/').slice(1))}
        }
      },
      "response": []
    }
  ]
}`;

    return (
      <>
        <Paragraph style={{ paddingTop: 10 }}>
          In your Postman workspace, click on Import. Paste the following code
          to send your first notification:
        </Paragraph>
        <CodeBlock language={this.language} code={code} />
      </>
    );
  }

  buildUserObject(user: User): UserObjectStringMap {
    return {
      id: `\\"id\\": \\"${user.id}\\"`,
      email: `\\"email\\": \\"${user.email}\\"`,
      number: `\\"number\\": \\"${user.number}\\"`
    };
  }
}
/* eslint-enable no-useless-escape */
